import type { MarketCode } from '@sharpr/types';

// `${gameId}|${playerId}|${market}`: our identity for a prop, the one prop_lines is keyed by (an OddsBlaze relisting or a
// renamed player is the same prop).
export type PropKey = `${string}|${string}|${MarketCode}`;
export const propKey = (gameId: string, playerId: string, market: MarketCode): PropKey => `${gameId}|${playerId}|${market}`;

// One book's line on a prop, identified by (key, book).
export interface PropLine {
  key: PropKey; market: MarketCode; book: string; line: number;
  over?: number; under?: number; overLimit?: number; underLimit?: number; overLink?: string; underLink?: string;
  removed?: boolean; updatedAt: number;
}

// The prices the board shows (American odds; null: no bound). A book's line with a side priced outside them is left off the
// board, as if the book had no market on the prop: a long over a book posts alone once its main line is pulled isn't its line.
export interface OddsRange { min: number | null; max: number | null }
export const ANY_ODDS: OddsRange = { min: null, max: null };
export const DEFAULT_ODDS_RANGE: OddsRange = { min: -400, max: 300 };
export function withinOddsRange({ min, max }: OddsRange, l: PropLine): boolean {
  return [l.over, l.under].every(odds => odds === undefined || ((min === null || odds >= min) && (max === null || odds <= max)));
}
